<template>
  <div id="pc" style="background:#ffffff">
    <div v-if="!isAllow" class="loading loading-fail">
      <i class="el-icon-close" style="font-size: 40px"></i>
      {{ errorMsg }}
    </div>
    <div
      v-else
      class="loading"
      v-loading="showLoading"
      element-loading-text="正在拼命初始化..."
      element-loading-background="transparent"
    >
      <location-picker />
      <current-conversation />
      <image-previewer />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CurrentConversation from '@/components/pc/conversation/current-conversation'
import ImagePreviewer from '@/components/pc/message/image-previewer.vue'
import LocationPicker from '@/components/pc/picker/location'
import MTA from '@/utils/mta'
import authAPI from '@/api/auth'
import httpAPI from '@/api/api'

export default {
  title: '迪粉汇',
  name: 'chat',
  components: {
    CurrentConversation,
    ImagePreviewer,
    LocationPicker,
  },

  data: () => ({
    errorMsg: '加载失败',
    routeArr: [],
  }),

  computed: {
    ...mapState({
      isLogin: (state) => state.user.isLogin,
      isSDKReady: (state) => state.user.isSDKReady,
      isAllow: (state) => state.user.isAllow,
      userID: (state) => state.user.userID,
      APPID: (state) => state.conversation.APPID,
      UID: (state) => state.conversation.UID,
      sign: (state) => state.conversation.sign,
      color: (state) => state.user.color,
      enterid: (state) => state.user.enterid,
      anonymity: (state) => state.user.anonymity,
      currentMessageList: (state) => state.conversation.currentMessageList,
      pageVisibleOrHidden: (state) => state.user.pageVisibleOrHidden,
    }),
    // 是否显示 Loading 状态
    showLoading() {
      return !this.isSDKReady
    },
  },

  created() {
    // 获取地址参数
    let color = this.$route.query.color
    let enterid = this.$route.query.enterid
    if (color) {
      this.$store.commit('color', color)
    }
    let appid = this.$route.query.appid
    let token = this.$route.query.auth
    let k = this.$route.query.k
    let arr = Object.keys(this.$route.query)
    this.routeArr = arr.filter((item) => {
      return item != 'color' && item != 'enterid'
    })
    if (this.routeArr.length == 0 || this.routeArr.length > 2) {
      this.errorMsg = '访问地址错误'
      this.$store.commit('toggleIsAllow', false)
      return
    }
    this.$store.commit({ type: 'setConversationInfo', APPID: appid })
    if (this.routeArr.length == 1) {
      if (token) {
        //兼容老版本 传token
        sessionStorage.setItem('token', token)
        this.$store.commit('toggleIsAllow', true)
      } else if (appid) {
        sessionStorage.setItem('appid', appid)
        sessionStorage.setItem('enterid', enterid)
        //匿名用户 localStorage存贮用户信息 携带localStorage
        if (localStorage.getItem(appid) && localStorage.getItem(appid) != '') {
          sessionStorage.setItem('token', localStorage.getItem(appid))
        } else {
          sessionStorage.removeItem('token')
        }
        this.$store.commit('setEnterID', enterid)
        this.$store.commit('setAnonymity', true)
        this.$store.commit('toggleIsAllow', true)
      } else {
        this.errorMsg = '访问地址错误'
        this.$store.commit('toggleIsAllow', false)
        return
      }
    } else {
      if (appid && k) {
        sessionStorage.setItem('appid', appid)
        sessionStorage.setItem('enterid', enterid)
        sessionStorage.setItem('k', k)
        sessionStorage.setItem(
          'token',
          decodeURIComponent(k.replace(/\s/g, '%2B'))
        )
        this.$store.commit('toggleIsAllow', true)
      } else if (appid && token) {
        //匿名
        sessionStorage.removeItem('token')
        this.$store.commit('setAnonymity', true)
        this.$store.commit('toggleIsAllow', true)
      } else {
        this.errorMsg = '访问地址错误'
        this.$store.commit('toggleIsAllow', false)
        return
      }
    }
    // 初始化监听器
    if (this.isAllow) {
      this.initListener()
      this.initTim()
    }
  },

  mounted() {},

  beforeDestroy() {
    window.tim = null
    window.TIM = null
    this.removeListener()
    this.tim.destroy()
    this.tim = null
  },
  watch: {
    isLogin(next) {
      if (next) {
        MTA.clickStat('link_two', { show: 'true' })
      }
    },
    pageVisibleOrHidden(state) {
      if (
        state == 'visible' &&
        sessionStorage.getItem('currentConversationID') &&
        sessionStorage.getItem('currentConversationID') != '' &&
        sessionStorage.getItem('currentSessionID') &&
        sessionStorage.getItem('currentSessionID') != ''
      ) {
        this.setMsgRead(
          sessionStorage.getItem('currentConversationID'),
          this.userID,
          sessionStorage.getItem('currentSessionID')
        )
      }
    },
  },
  methods: {
    setMsgRead(currentConversationID, fromAccount, sessId) {
      if (this.isSDKReady) {
        tim.setMessageRead({ conversationID: currentConversationID })
        httpAPI.setMsgRead({ fromAccount: fromAccount, sessId: sessId })
      }
    },
    initTim() {
      let params = { appid: this.APPID }
      if (this.anonymity) {
        params['enterid'] = this.enterid
      }
      if (this.$route.query.appid) {
        let onceAnonymityUserID = localStorage.getItem('onceAnonymityUserID')
        if (onceAnonymityUserID && onceAnonymityUserID != '') {
          params['user_info_id'] = onceAnonymityUserID
        }
      }
      let custData = ''
      authAPI
        .getCustId(params)
        .then((imResponse) => {
          custData = imResponse
          this.$store.commit('setEnterID', custData.enterid)
          this.$store.commit('setZhujian', custData.zhujian_appid)
          if (custData.k) {
            localStorage.setItem(custData.appid, custData.k)
            sessionStorage.setItem('token', custData.k)
          }
          if (this.anonymity) {
            localStorage.setItem('onceAnonymityUserID', custData.user_info_id)
          } else {
            localStorage.removeItem('onceAnonymityUserID')
          }
          this.$store.commit('setNickname', custData.nickname || '匿名')
          this.$store.commit({
            type: 'setConversationInfo',
            APPID: custData.appid,
            UID: custData.user_id,
            sign: custData.organization_id,
          })
          this.$store.commit({
            type: 'setHeaderInfo',
            channelname: custData.title,
            headerUrl: custData.head_img,
          })
          let genSign = ''
          authAPI
            .getTIMGenSIg({ identifier: custData.user_info_id })
            .then((sigData) => {
              genSign = sigData
              this.tim.login({
                userID: custData.user_info_id.toString(),
                userSig: genSign,
              })
              this.$store.commit({
                type: 'setUserInfo',
                userID: custData.user_info_id,
                headimgurl: custData.h5imgurl,
                userSig: genSign,
              })
            })
            .catch((err) => {
              console.warn('get Sig error', err)
              this.$store.commit('toggleIsAllow', false)
            })
        })
        .catch((imError) => {
          console.warn('get custID error:', imError)
          this.errorMsg = imError
          this.$store.commit('toggleIsAllow', false)
        })
    },

    /**
     * 更新个人信息（包含TIM服务器和BYD服务器）
     */
    updateUserProfile() {
      // let nick = this.$route.query.nickname
      // let avatar = this.$route.query.avatar
      // IM服务器
      // if (nick) {
      //   this.tim.updateMyProfile({
      //     nick
      //   })
      // }
      // BYD服务器
      let promise = authAPI.updateUserInfo({
        uid: this.UID,
        appid: this.APPID,
        // name: nick,
        // nickname: nick,
        // headimgurl: avatar,
      })
      promise
        .then(function() {})
        .catch(function(imError) {
          console.warn('updateMyProfile error:', imError) // 更新资料失败的相关信息
        })
    },

    initListener() {
      // 登录成功后会触发 SDK_READY 事件，该事件触发后，可正常使用 SDK 接口
      this.tim.on(this.TIM.EVENT.SDK_READY, this.onReadyStateUpdate, this)
      // SDK NOT READT
      this.tim.on(this.TIM.EVENT.SDK_NOT_READY, this.onReadyStateUpdate, this)
      // 被踢出
      this.tim.on(this.TIM.EVENT.KICKED_OUT, this.onKickOut)
      // SDK内部出错
      this.tim.on(this.TIM.EVENT.ERROR, this.onError)
      // 收到新消息
      this.tim.on(this.TIM.EVENT.MESSAGE_RECEIVED, this.onReceiveMessage)
      // 收到消息被撤回的通知
      this.tim.on(this.TIM.EVENT.MESSAGE_REVOKED, this.onRevokedMessage)
      // 会话列表更新
      this.tim.on(
        this.TIM.EVENT.CONVERSATION_LIST_UPDATED,
        this.onUpdateConversationList
      )
      // 群组列表更新
      // this.tim.on(this.TIM.EVENT.GROUP_LIST_UPDATED, this.onUpdateGroupList)
      // 网络监测
      this.tim.on(this.TIM.EVENT.NET_STATE_CHANGE, this.onNetStateChange)
      // 已读回执
      this.tim.on(this.TIM.EVENT.MESSAGE_READ_BY_PEER, this.onMessageReadByPeer)
    },

    removeListener() {
      // 登录成功后会触发 SDK_READY 事件，该事件触发后，可正常使用 SDK 接口
      this.tim.off(this.TIM.EVENT.SDK_READY, this.onReadyStateUpdate)
      // SDK NOT READT
      this.tim.off(this.TIM.EVENT.SDK_NOT_READY, this.onReadyStateUpdate)
      // 被踢出
      this.tim.off(this.TIM.EVENT.KICKED_OUT, this.onKickOut)
      // SDK内部出错
      this.tim.off(this.TIM.EVENT.ERROR, this.onError)
      // 收到新消息
      this.tim.off(this.TIM.EVENT.MESSAGE_RECEIVED, this.onReceiveMessage)
      // 撤回消息
      this.tim.off(this.TIM.EVENT.MESSAGE_REVOKED, this.onRevokedMessage)
      // 会话列表更新
      this.tim.off(
        this.TIM.EVENT.CONVERSATION_LIST_UPDATED,
        this.onUpdateConversationList
      )
      // 群组列表更新
      // this.tim.off(this.TIM.EVENT.GROUP_LIST_UPDATED, this.onUpdateGroupList)
      // 网络监测
      this.tim.off(this.TIM.EVENT.NET_STATE_CHANGE, this.onNetStateChange)
      // 已读回执
      this.tim.off(
        this.TIM.EVENT.MESSAGE_READ_BY_PEER,
        this.onMessageReadByPeer
      )
    },
    /**
     * 处理撤回消息的函数
     */
    onRevokedMessage({ data: revokesMsgList }) {
      if (revokesMsgList['0'].from === revokesMsgList['0'].to) return
      let currentMessageList = this.currentMessageList.map((item) => {
        if (revokesMsgList['0'].ID == item.ID) {
          item.isRevoked = true
        }
        return item
      })
      this.$store.commit('pushCurrentMessageList', currentMessageList)
    },
    onMessageReadByPeer({ data: readMsgList }) {
      let readMsgListArr = []
      readMsgList.forEach((ele) => {
        if (
          ele.from != ele.to &&
          ele.payload.extension != 'Typing' &&
          ele.payload.extension != 'CancelTyping'
        ) {
          readMsgListArr.push(ele.ID)
        }
      })
      if (readMsgListArr.length == 0) return
      let currentMessageList = this.currentMessageList.map((item) => {
        if (readMsgListArr.includes(item.ID)) {
          item.isReaded = true
        }
        return item
      })
      this.$store.commit('pushCurrentMessageList', currentMessageList)
    },
    onReceiveMessage({ data: messageList }) {
      let formatMessageList = []
      messageList.forEach((item) => {
        if (
          item.payload.extension != 'Typing' &&
          item.payload.extension != 'CancelTyping'
        ) {
          console.log('Log: onReceiveMessage -> 收到信息', item)
          if (document.visibilityState == 'visible') {
            sessionStorage.setItem('currentConversationID', item.conversationID)
            sessionStorage.setItem(
              'currentSessionID',
              JSON.parse(item.payload.data).session_id
            )
            this.setMsgRead(
              item.conversationID,
              this.userID,
              JSON.parse(item.payload.data).session_id
            )
          }
          let newItem = {
            ID: item.ID,
            sessionId: JSON.parse(item.payload.data).session_id,
            content: JSON.parse(item.payload.data).content,
            headimgurl: JSON.parse(item.payload.data).headimgurl,
            nickname: JSON.parse(item.payload.data).nickname,
            realType: JSON.parse(item.payload.data).type,
            type:
              JSON.parse(item.payload.data).evaluate_msg == '1'
                ? 'text-evaluate'
                : item.payload.extension,
            state: JSON.parse(item.payload.data).state,
            sendFrom: JSON.parse(item.payload.data).send_from,
            createTime: item.time,
            conversationType: item.conversationType,
            isRevoked:
              JSON.parse(item.payload.data).evaluate_msg == '1'
                ? true
                : item.isRevoked,
            evaluate_msg: JSON.parse(item.payload.data).evaluate_msg || '0', //是否是满意度消息 1--是满意度 其他--不是
            evaluation_way: JSON.parse(item.payload.data).evaluation_way || '1', //满意度评价类型 1--数字 2--星星 3--表情
            grade: '0', //满意度评价 0--未评价 1--非常好 2--好 3--不好 4--差劲
            satisfaction_is_expired: '2', //满意度评价是否过期 1--过期 2--未过期
            robot_appid: JSON.parse(item.payload.data).robot_appid,
            uuid: JSON.parse(item.payload.data).uuid,
            robot_type: JSON.parse(item.payload.data).robot_type,
            //isFreshQuene判断该消息体是否为更新排队信息的消息体
            isFreshQuene:
              JSON.parse(item.payload.data).type == 9 &&
              typeof JSON.parse(item.payload.data).content == 'number',
            no_match:
              JSON.parse(item.payload.data).no_match == 1 ? true : false,
          }
          if (
            JSON.parse(item.payload.data).evaluate_msg &&
            (JSON.parse(item.payload.data).evaluate_msg == '1' ||
              JSON.parse(item.payload.data).evaluate_msg == '2')
          ) {
            newItem['evaluate_msg'] = JSON.parse(item.payload.data).evaluate_msg
            newItem['content']['se_id'] = newItem['sessionId']
          }
          //切换对话的客服账号
          if (
            item.type == this.TIM.TYPES.MSG_CUSTOM &&
            item.conversationType == this.TIM.TYPES.CONV_C2C
          ) {
            // 非本人的消息都视为客服消息
            if (item.from != this.userID) {
              this.$store.commit({
                type: 'updateConversation',
                toAccount: item.from,
                convType: item.conversationType,
              })
            }
            // 结束会话转群组消息
            if (item.payload.extension == this.TYPES.MSG_TYPE.QUIT) {
              this.$store.commit({
                type: 'setNeedAssignCustomer',
                isNeedAssignCustomer: true,
              })
            }
          }
          //排队人数刷新
          if (newItem.isFreshQuene) {
            let index
            console.log('更新排队人数')
            let msgList = [...this.currentMessageList]
            //获取要更新消息体的下标
            index = msgList.reverse().findIndex((i) => {
              if (typeof i.content == 'string') {
                return i.content.indexOf('请耐心等待，前面还有') != -1
              }
            })
            console.log('更新中')
            //获取排队刷新的接口url
            let outQueneUrl = this.currentMessageList[
              this.currentMessageList.length - 1 - index
            ].content.split('"')[3]
            //更新消息体
            this.currentMessageList[
              this.currentMessageList.length - 1 - index
            ].content = `请耐心等待，前面还有*${newItem.content}*位用户在排队 <a class="out_queue" href="${outQueneUrl}" onclick="return false">退出排队</a>`
            localStorage.setItem(
              `fb_waiting_${newItem.sessionId}`,
              newItem.content.toString()
            )
          }
          this.$store.dispatch('formatSendTime', newItem)
          formatMessageList.push(newItem)
        } else {
          if (item.payload.extension == 'Typing') {
            this.$store.commit('importState', true)
          } else if (item.payload.extension == 'CancelTyping') {
            this.$store.commit('importState', false)
          }
        }
      })
      if (formatMessageList.length != 0)
        this.$store.commit('pushCurrentMessageList', formatMessageList)
    },

    onError({ data }) {
      if (data.message !== 'Network Error') {
        this.$store.commit('showMessage', {
          message: data.message,
          type: 'error',
        })
      }
    },

    onReadyStateUpdate({ name }) {
      const isSDKReady = name === this.TIM.EVENT.SDK_READY ? true : false
      this.$store.commit('toggleIsSDKReady', isSDKReady)
      if (isSDKReady) {
        this.updateUserProfile()
        this.tim
          .getMyProfile()
          .then(({ data }) => {
            this.$store.commit('updateCurrentUserProfile', data)
          })
          .catch((error) => {
            this.$store.commit('showMessage', {
              type: 'error',
              message: error.message,
            })
          })

        this.$store.dispatch('getSessionList', 'auto')
      }
    },

    kickedOutReason(type) {
      switch (type) {
        case this.TIM.TYPES.KICKED_OUT_MULT_ACCOUNT:
          return '您的账号已在其他地方登录，请重新登录。'
        case this.TIM.TYPES.KICKED_OUT_MULT_DEVICE:
          return '您的账号已在其他地方登录，请重新登录。'
        case this.TIM.TYPES.KICKED_OUT_USERSIG_EXPIRED:
          return '由于 userSig 过期，请重新登录。'
        default:
          return ''
      }
    },

    checkoutNetState(state) {
      switch (state) {
        case this.TIM.TYPES.NET_STATE_CONNECTED:
          return { message: '已接入网络', type: 'success' }
        case this.TIM.TYPES.NET_STATE_CONNECTING:
          return { message: '当前网络不稳定', type: 'warning' }
        case this.TIM.TYPES.NET_STATE_DISCONNECTED:
          return { message: '当前网络不可用', type: 'error' }
        default:
          return ''
      }
    },

    onNetStateChange() {
      // this.$store.commit('showMessage', this.checkoutNetState(event.data.state))
    },

    onKickOut(event) {
      this.$store.commit('toggleIsAllow', true)
      // // this.$store.commit('toggleIsAllow', false)
      this.$store.commit('showMessage', {
        message: `${this.kickedOutReason(event.data.type)}`,
        type: 'error',
      })
      // this.$store.commit('toggleIsLogin', false)
      // this.$store.commit('reset')
    },

    onUpdateConversationList(event) {
      this.$store.commit('updateConversationList', event.data)
    },

    /**
     * 使用 window.Notification 进行全局的系统通知
     * @param {Message} message
     */
    notifyMe(message) {
      // 需检测浏览器支持和用户授权
      if (!('Notification' in window)) {
        return
      } else if (window.Notification.permission === 'granted') {
        this.handleNotify(message)
      } else if (window.Notification.permission !== 'denied') {
        window.Notification.requestPermission().then((permission) => {
          // 如果用户同意，就可以向他们发送通知
          if (permission === 'granted') {
            this.handleNotify(message)
          }
        })
      }
    },

    handleNotify(message) {
      const notification = new window.Notification('有人提到了你', {
        icon:
          'https://webim-1252463788.file.myqcloud.com/demo/img/logo.dc3be0d4.png',
        body: message.payload.text,
      })
      notification.onclick = () => {
        window.focus()
        this.$store.dispatch('checkoutConversation', message.conversationID)
        notification.close()
      }
    },
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$bus.$emit('scroll-bottom')
    })
  },
}
</script>

<style lang="stylus">
body {
    overflow: hidden;
    margin: 0;
    font-family: 'Microsoft YaHei', '微软雅黑', 'MicrosoftJhengHei', 'Lantinghei SC', 'Open Sans', Arial, 'Hiragino Sans GB', 'STHeiti', 'WenQuanYi Micro Hei', SimSun, sans-serif;
    background-color: $bg;
    -ms-scroll-chaining: chained;
    -ms-overflow-style: none;
    -ms-content-zooming: zoom;
    -ms-scroll-rails: none;
    -ms-content-zoom-limit-min: 100%;
    -ms-content-zoom-limit-max: 500%;
    -ms-scroll-snap-type: proximity;
    -ms-scroll-snap-points-x: snapList(100%, 200%, 300%, 400%, 500%);
    -ms-overflow-style: none;
    overflow: auto;

    div {
        box-sizing: border-box;

        &::before, &::after {
            box-sizing: border-box;
        }
    }
}

#wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
}

.container {
    position: relative;
    height: 100vh;
}

// TODO filter mac chrome 会有问题，下次修改可以去掉
.bg {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: -1;
    background-size: cover;
}

.loading {
    height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
}

.loading-fail {
    color: $primary;
    background: #fff;
    flex-direction: column;
}

.text-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 250px;
}

.chat-wrapper {
    margin-top: 8vh;

    @media screen and (max-width: 924px) {
        height: 100vh;
        width: 100vw;
    }

    @media screen and (min-width: 925px) {
        height: 76vh;
        width: 44vw;
    }

    box-shadow: 0 11px 20px 0 rgba(0, 0, 0, 0.3);

    .official-link {
        display: flex;
        text-decoration: none;
        color: #38c9ff;
        width: fit-content;
        float: right;
        height: 45px;
        align-items: center;
    }
}

/* 设置滚动条的样式 */
::-webkit-scrollbar {
    width: 3px;
    height: 3px;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
    border-radius: 10px;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.1);
}
</style>
